import dateTimeFormat from '@/i18n/date-time-format';
import { organizationData } from '@/store/helpers';
import { ref } from 'vue';

export function useIntl() {
  const { user } = organizationData();
  const formatToUse = ref(dateTimeFormat[user.value?.dateFormat || 'en-US']);
  return {
    dateTimeFormat: formatToUse,
  };
}
